export {
    generateDeterministicId,
    generateDeterministicTemplateId,
    generateDeterministicTemplateIdFromTemplateIdAndEntityId,
    generateDeterministicTemplateIdFromTemplateIdAndStringKey,
    generateDeterministicTemplateIdFromTemplateIdAndTemplateId,
    generateId,
    hexStringToBigInt,
    hexStringToDecimalString,
    makeUUID,
    type DeterministicIdKey,
} from "@archipad-js/core/orm";
